import React, {useEffect, useRef, useState} from 'react';
import {useEdgeBuilder} from "../../association-network-context.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import Button from "../../../../../../components/button/button.jsx";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import {useQuery} from "@tanstack/react-query";
import groupService from "../../../../../../services/web/group-service.js";
import SelectComponent from "../../../../../../components/select/select-component.jsx";

const Init = ({show, analysisData, setAnalysisData, nameRequired = false, setNameRequired = () => {}}) => {
    const [firstTimeCloseModal, setFirstTimeCloseModal] = useState(false)
    const [name, setName] = useState("")
    const [stateGroups, setStateGroups] = useState([])
    const nameInputRef = useRef(null)
    const {setPanelOpened, id} = useEdgeBuilder()

    const {data: groups = []} = useQuery({
        queryFn: () => groupService.getOptionsMyUser("association_network"),
        queryKey: ["groups"],
        initialData: []
    })

    useEffect(() => {
        setName(analysisData.name)
        setStateGroups(analysisData.groups)
    }, [analysisData]);

    useEffect(() => {
        if (!show || !nameRequired) return;

        const timeout = setTimeout(() => nameInputRef.current?.focus(), 0);
        return () => clearTimeout(timeout);
    }, [show, nameRequired]);

    const init = () => {
        setAnalysisData({name, groups: stateGroups})

        if (firstTimeCloseModal) cancel()
        else {
            setFirstTimeCloseModal(true)
            setPanelOpened("search")
        }
    }

    const cancel = () => {
        setPanelOpened(null)
        setFirstTimeCloseModal(true)
    }

    const setOpen = () => {
        setPanelOpened(null)
    }

    return (
        <>
            <Modal overflow={true} open={show} setOpen={setOpen} title={id ? "Editar rede de associação" : "Nova rede de associação"} className={"w-3/12"}>
                <Modal.Body>
                    <SentryRow>
                        <InputForm
                            classNameWrapper={"col-span-12"}
                            id="name"
                            inputRef={nameInputRef}
                            value={name}
                            label="Nome da rede *"
                            required
                            invalid={nameRequired}
                            onChange={({target: {value}}) => {
                                setName(value);
                                if (value.trim()) setNameRequired(false);
                            }}
                        />
                        <SelectComponent
                            classNameWrapper={"col-span-12"}
                            id="group"
                            isMulti
                            options={groups}
                            value={
                                groups.filter(group =>
                                    stateGroups?.includes(group.value)
                                )
                            }
                            label="Grupo de operação"
                            onChange={(selected) => {
                                setStateGroups(selected.map(el => el.value))
                            }}
                        />
                    </SentryRow>
                </Modal.Body>

                <Modal.Footer className={"p-1"}>
                    <div className={"flex justify-end gap-2"}>
                        <Button className={"float-right"} onClick={() => init()}>Confirmar</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Init;